import React from "react";
import {} from "../../../Redux/Actions/actions";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
  const { contactListData } = state;
  return {
    cobrowsChatLink: contactListData.cobrowsChatLink,
  };
};
const CobrowseChat = (props) => {
  return (
    <div className="d-flex justify-content-center h-100 w-100">
      <iframe
        src={props.cobrowsChatLink.link}
        style={{ width: "100vw", height: "90vh" }}
      ></iframe>
    </div>
  );
};

export default connect(mapStateToProps, {})(CobrowseChat);
